import '../premiumLanding.css';

export default function CoreBaseHero({ isAuthenticated, onLogin }) {
  return (
    <section className="pl-hero">
      <div className="pl-wrap">
        <span className="pl-eyebrow">CRM para negocios de servicios</span>
        <h1>CoreBase</h1>
        <p className="pl-hero-sub">
          El sistema que organiza y controla tu negocio.{' '}
          <strong>
            Gestiona clientes, controla pagos, ordena tu información y ten claridad de lo
            que pasa en tu negocio.
          </strong>
        </p>
        <p className="pl-hero-note">Gratis hasta 3 vendedores · Extra: USD 1/mes o USD 10/año por vendedor</p>
        {!isAuthenticated && <div className="pl-cta-row"><button type="button" className="pl-btn pl-btn-accent" onClick={onLogin}>Comenzar gratis</button></div>}
      </div>
    </section>
  );
}
